module.exports = __webpack_public_path__ + "media/images/app/how-it-works/mid-mobile-4ee2fa8b967fdac28162a9b71af75cd6.webp";